<template>
	<div class="wrapper">
		<top-bar/>
		<side-bar :disabledOptions="showNoData"/>
		<transition v-show="!showNoData" name="fade" mode="out-in">
			<router-view/>
		</transition>
		<no-data v-show="showNoData"/>
	</div>
</template>

<script>
export default {
	computed: {
		showNoData () {
			return this.$store.state.ui.showNoData;
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/routes/languages/Languages.vue